"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormControlOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        marginNormal: {
            marginTop: spacing(3),
            marginBottom: spacing(1),
        },
    });
};
//# sourceMappingURL=MuiFormControl.js.map